import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { track } from '../lib/analytics';

export default function RouteTracker() {
  const location = useLocation();
  const { user } = useAuth();
  const firstFire = useRef(true);

  useEffect(() => {
    if (user?.role === 'ADMIN') return;
    if (location.pathname.startsWith('/admin') || location.pathname === '/login') return;

    const referrer = firstFire.current ? (document.referrer || null) : null;
    firstFire.current = false;
    track('PAGEVIEW', location.pathname, referrer);
  }, [location.pathname, user]);

  return null;
}
